module.exports = __webpack_public_path__ + "486efc37e9228d5965f0b5490fa2633a.svg";